import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FaBan } from "react-icons/fa";
import { cancelPurchaseRequest, getPurchaseRequest } from "redux/erp/purchaseRequestSlice";
import { Modal, Button, FormInput } from 'components/common';

// Khác với Reject (người ký từ chối tại bước ký) — Cancel là người lập tự huỷ
// HẲN phiếu của mình (còn draft hoặc đang pending). Cả 2 đều là trạng thái cuối:
// không sửa/submit lại được, muốn làm lại thì Duplicate sang phiếu mới.
const CancelForm = ({ show, onHide, purchaseRequest }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async () => {
    setBusy(true);
    try {
      await dispatch(cancelPurchaseRequest({ id: purchaseRequest.id, comment })).unwrap();
      await dispatch(getPurchaseRequest(purchaseRequest.id));
      toast.success("Purchase requisition canceled.");
      onHide();
    } catch (e) { toast.error(e?.error || e?.message || "Cancel failed."); }
    finally { setBusy(false); }
  };

  return (
    <Modal show={show} onHide={onHide} title={`Cancel ${purchaseRequest?.code}`} size="md"
      footer={<>
        <Button variant="secondary" size="sm" disabled={busy} onClick={onHide}>Back</Button>
        <Button variant="danger" size="sm" leftIcon={FaBan} disabled={busy} onClick={onSubmit}>Cancel request</Button>
      </>}>
      <div className="geist-scope">
        <p className="tw-text-sm tw-text-geist-fg-2 tw-mt-0">
          This permanently cancels the requisition — it can no longer be edited or submitted.
          Use Duplicate afterwards if you want to reuse its content in a new requisition.
        </p>
        <FormInput label="Cancel reason (optional)" type="textarea" rows={3} value={comment} onChange={(e) => setComment(e.target.value)} />
      </div>
    </Modal>
  );
};

CancelForm.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  purchaseRequest: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    code: PropTypes.string,
  }),
};

export default CancelForm;
